import 'common';
import 'lazysizes';

import(/* webpackChunkName: "AddressSearchForm" */ 'address_search_form').then(module =>
  new module.AddressSearchForm().mount()
);
import(/* webpackChunkName: "dateTimeFieldsPickers" */ 'date_time_fields_pickers').then(module =>
  module.dateTimeFieldsPickers()
);
import(/* webpackChunkName: "Accordion" */ 'accordion').then(module =>
  new module.Accordion().mount()
);
import(/* webpackChunkName: "sideNav" */ 'side_nav').then(module => module.sideNav());
import(/* webpackChunkName: "Dropdown" */ 'dropdown').then(module => new module.Dropdown().mount());
import(/* webpackChunkName: "transcend" */ 'transcend').then(module =>
  module.setupTranscendClick()
);

document.querySelectorAll('[data-scroll-smooth-to]').forEach(categoryLink => {
  categoryLink.addEventListener('click', event => {
    event.preventDefault();

    const scrollToTarget = document.querySelector(event.target.dataset.scrollSmoothTo);

    scrollToTarget &&
      import(/* webpackChunkName: "scrollSmoothTo" */ 'scroll_smooth_to').then(module =>
        module.scrollSmoothTo(scrollToTarget, {duration: 500})
      );
  });
});

if (document.getElementById('promo_auto_applied_banner')) {
  import(
    /* webpackChunkName: "promoAutoAppliedManager" */ 'promo_auto_applied_manager'
  ).then(module => {
    module.promoAutoAppliedManager();
  });
}
